import script from "./QuickSetupChat.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickSetupChat.vue?vue&type=script&setup=true&lang=js"

import "./QuickSetupChat.vue?vue&type=style&index=0&id=5d8c8f65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8c8f65"]])

export default __exports__